module.exports = __webpack_public_path__ + "media/images/prediction/special/auto/img_logo_auto-a733d6e8a9e254cd206acb13042badfd.jpg";